import React from "react";
import Link from "gatsby-link";

import logo from "./../../images/Seattle-By-Bike-logo.svg";

const Header = () => {
  const handleClick = function(event) {
    const el = document.getElementById("nav");

    event.preventDefault();
    el.classList.toggle("block");
    el.classList.toggle("hidden");
  };

  return (
  <header className="bg-brand-blue bg-top header h-screen" id="home"  data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
    
    <nav className="bg-transparent">
        <div className="bg-brand-white">
            <div className="flex items-center text-xs lg:text-sm font-semibold px-3 lg:px-6 py-3 lg:py-3 leading-normal max-w-xl mx-auto" role="alert">
            <svg className="hidden lg:inline-block fill-current text-brand-orange w-4 h-4 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"></path>
            </svg>
            <div>
                          <p className="text-brand-blue text-sm lg:text-base ">Seattle by Bike is not taking reservations for the Summer 2024 season. We hope to reopen for Summer 2025. All the best and hope to see you then!</p>
                <span className="font-light ml-3 text-brand-blue text-xs lg:text-sm"> - Staff at Seattle by Bike</span>
                {/* <p className="text-brand-blue text-xs lg:text-sm ">From September to July, Seattle by Bike tours are often limited to weekends. If you don't see the day and tour available that you'd like, call us <a className="text-brand-blue" href="tel:206-880-0853">(206-880-0853)</a> and we will do our best to accommodate your request. Thanks!</p>
                <span className="font-light ml-3 text-brand-blue text-xs lg:text-sm "> - Staff at Seattle by Bike</span> */}
            </div>
            </div>
        </div>  
      
      <div className="flex flex-wrap items-center justify-between max-w-xl mx-auto p-4 md:p-8 z-10">
        
        <Link to="/" className="flex items-center no-underline text-brand-white hover:text-brand-orange uppercase tracking-wide font-title  hover:text-brand-orange">
          <img 
            src={logo} 
            alt="Seattle By Bike Logo"
            className="fill-current text-brand-white hover:text-brand-orange h-32">
          </img>
          <span className="font-bold text-xl tracking-tight ml-4">
            
          </span>
        </Link>

        <button
          className="block md:hidden border border-brand-white flex items-center px-3 py-2 rounded text-brand-white hover:text-brand-orange"
          onClick={handleClick}
        >
          <svg
            className="fill-current h-3 w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>

        <div
          id="nav"
          className="hidden md:flex md:items-center w-full md:w-auto"
        >
          <div className="text-sm">
            
            <a
              href="/#tours"
              className="block md:inline-block mt-4 md:mt-0 mr-6 no-underline text-brand-white hover:text-brand-orange uppercase tracking-wide font-title" 
            >
              Tours
            </a>

            <a
              href="/#faq"
              className="block md:inline-block mt-4 md:mt-0 mr-6 no-underline text-brand-white hover:text-brand-orange uppercase tracking-wide font-title" 
            >
              FAQ
            </a>

            <a
              href="/#about"
              className="block md:inline-block mt-4 md:mt-0 no-underline text-brand-white hover:text-brand-orange uppercase tracking-wide font-title" 
            >
              About
            </a>
            
          </div>
        </div>
      </div>
    </nav>

    <div className="text-center text-brand-white w-5/6 max-w-xl ml-auto mr-auto h-full">
      <div className="flex items-center justify-center text-center h-half">
        <div>
          <h1 className="font-title font-bold mb-8 w-3/4 mx-auto">Make memories of a lifetime with Seattle's best guided bike tour</h1>
          <p className="font-title font-semibold mb-8 w-3/4 mx-auto hidden" >Seattle by Bike offers guided bicycle tours
          that make memories and explore the best sights and sounds of the Emerald City.</p>
          {/* <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-500 fb-entity-config-id- fb-domain-go.theflybook.com fb-protocol-https">
            Book Now
          </button> */}
            <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed" disabled>
                Closed for now - hopefully coming back in 2025!
            </button>
        </div>
      </div>
    </div>

  </header>    
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js